<template>
    <div class="circle" :class="type">
        <slot></slot>
    </div>
</template>

<script>
	export default {
		name: "CircleWrapWrap",
        props: ['type']
	}
</script>

<style lang="scss" scoped>
    .circle{
        display: block;
        width: 68px;
        height: 68px;
        border-radius: 50%;
        background: $orange;
        border: 2px solid $white;
        box-shadow: 0px 2px 4px rgba(0,0,0,0.5);
        svg{
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%,-50%);
        }
        &.back{
            cursor: pointer;
        }
    }
</style>
